// extracted by mini-css-extract-plugin
module.exports = {"example":"CreateTagAsyncDropdownOption__example--38JMq"};